var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.789 313.693C286.051 322.185 271.255 326.674 256 326.674C240.746 326.674 225.95 322.185 213.212 313.693L3.409 173.82C2.245 173.044 1.111 172.235 0 171.403V400.6C0 426.878 21.325 447.733 47.133 447.733H464.866C491.144 447.733 511.999 426.408 511.999 400.6V171.402C510.886 172.236 509.75 173.047 508.583 173.824L298.789 313.693Z",
    fill: "#695F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.05 148.858L229.853 288.732C237.795 294.027 246.897 296.674 255.999 296.674C265.102 296.674 274.205 294.026 282.147 288.732L491.95 148.858C504.505 140.493 512 126.493 512 111.383C512 85.4021 490.863 64.2661 464.883 64.2661H47.117C21.137 64.2671 0 85.4031 0 111.408C0 126.493 7.496 140.493 20.05 148.858Z",
    fill: "#695F5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailFilled);
export default __webpack_public_path__ + "static/media/mail-filled.a581161584297c480bc6ea1c002de4ad.svg";
export { ForwardRef as ReactComponent };